'use client';

import React, { useEffect } from 'react';
import Image from 'next/image';
import styles from '../../styles/about.module.scss';
import Navbar from '../navbar';
import { useTranslations } from 'next-intl';

import useStore from '@store/index';
import Link from 'next/link';
import { submitCollection, submitSets } from '_services/submit.service';

interface AboutLoadObj {
  details: string;
  telephone: string;
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: string;
  }
  email: string;
}

export default function AboutComponent() {
  const t = useTranslations();
  const { companyDetails, hasHydrated } = useStore((state) => state);

  const [aboutData, setAboutData] = React.useState<AboutLoadObj | null>(null);

  useEffect(() => {
    const fetchAboutUs = async () => {
      const response = await submitSets(submitCollection.loadAboutUs, {
        locationId: companyDetails?.locationId || null,
      }, false, null);

      // console.log("About us data:", response);
      
      
      if(response && response.status && response.extra && typeof response.extra === "object" && response.extra !== null){
        setAboutData(response.extra as AboutLoadObj);
      }
    }

    fetchAboutUs();
  }, [hasHydrated]);

  // console.log(companyDetails);
  
  return (<>
    <Navbar pageTitle={t("About.title")} isShowFulfillmentDetails={false} isBackButtonVisible={true} />

    <div className={styles.aboutPage}>
      {/* Main Logo */}
      <div className={styles.logoContainer}>
        <Image 
          src="/assets/images/main-logo.png" 
          alt="Farmhouse Pizza Logo"
          width={238}
          height={199}
          className={styles.mainLogo}
        />
      </div>

      {/* About Text */}
      <div className={styles.aboutText}>
        <h1 className={styles.aboutTitle}>{t("About.title")} {companyDetails?.name || 'Farmhouse Pizza - Manjimup'}</h1>
        <p>
          {aboutData?.details || t('About.comingSoon')}
        </p>
      </div>

      {/* Contact Information */}
      <div className={styles.contactSection}>
        {/* Phone Contact */}
        <div className={styles.contactCard}>
          <div className={styles.contactInfo}>
            <h4>{t("About.phone")}</h4>
            <p>{aboutData?.telephone || t('About.comingSoon')}</p>
          </div>
          <div className={styles.contactActions}>
            {/* <Link href={`/chat`} className={styles.actionButton} aria-label="Chat with us">
              <Image src="/assets/images/chat-icon.svg" alt="Chat" width={18} height={17} />
            </Link> */}
            <Link href={`tel:${aboutData?.telephone || ''}`} className={styles.actionButton} aria-label="Call us">
              <Image src="/assets/images/phone-icon.svg" alt="Phone" width={18} height={18} />
            </Link>
          </div>
        </div>

        {/* Address Contact */}
        <div className={styles.contactCard}>
          <div className={styles.contactInfo}>
            <h4>{t("About.address")}</h4>
            <p>{aboutData?.address ? `${aboutData.address.addressLine1}, ${aboutData.address.addressLine2}, ${aboutData.address.city}, ${aboutData.address.country}` : t('About.comingSoon')}</p>
          </div>
          <div className={styles.contactActions}>
            <Link href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(aboutData?.address ? `${aboutData.address.addressLine1}, ${aboutData.address.addressLine2}, ${aboutData.address.city}, ${aboutData.address.country}` : 'Coming soon...')}`} target='_blank' className={styles.actionButton} aria-label="View on map">
              <Image src="/assets/images/location-icon.svg" alt="Location" width={14.67} height={16.63} />
            </Link>
          </div>
        </div>

        {/* Email Contact */}
        <div className={styles.contactCard}>
          <div className={styles.contactInfo}>
            <h4>{t("About.email")}</h4>
            <p>{aboutData?.email ? `${aboutData.email}` : t('About.comingSoon')}</p>
          </div>
          <div className={styles.contactActions}>
            <a href={`mailto:${aboutData?.email || ''}`} className={styles.actionButton} aria-label="Send Email">
              <Image src="/assets/images/email-icon.svg" alt="Email" width={20} height={15} />
            </a>
          </div>
        </div>
      </div>
    </div>
  </>);
}